import styles from './LoadingSpinner.module.css';

function LoadingComponent() {
    return (
        <div className={styles.loader_container}>
            <div className={styles.spinner} />
        </div>
    );
}

export default LoadingComponent;
